<script lang="ts">
  import { Header, Separator } from "./mod.ts";
  import { Hor, Spacer, Ver } from "./mod.ts";

  export let title: string = "";
  export let noMargin: boolean = false;
  export let buttonTitle: string = "";
  export let buttonClick: () => void = () => {};
  export let rightTitleElem: (() => any) | undefined = undefined;
  export let content: () => any;
</script>

<div class="break-inside-avoid w-full mb-[16px]">
  <div
    class="max-mobile:bg-white bg-[#F5F9FA] border-[0.5px] border-[#CCE2DF] rounded-[10px] shadow-card"
  >
    <Ver full={false} margin="m" gap="none">
      <Hor margin="none">
        <Header size="4">
          {title}
        </Header>
        <Spacer></Spacer>
        <button
          on:click={buttonClick}
          class="flex items-center text-[14px] font-medium underline"
          class:hidden={!buttonTitle}
        >
          {buttonTitle}
        </button>
        {@render rightTitleElem?.()}
      </Hor>
    </Ver>
    <Separator />
    <Ver margin={noMargin ? "none" : "m"} gap="none">
      <Ver grow>
        {@render content()}
      </Ver>
    </Ver>
  </div>
</div>
